import styled from 'styled-components';


export const Upload = styled.input``;

export const UploadButton = styled.div``;



export const UploadButtonText = styled.div`
  color: #666;
`;

export const UploadVideo = styled.div`
  &.upload-img {
    width: 128px;
    height: 128px;

    display: table;
    width: 104px;
    height: 104px;
    text-align: center;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    transition: border-color 0.3s ease;

    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    outline: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      border-color: #1890ff;
    }
    ${Upload} {
      display: none;
    }
  }
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
`;
